import React from 'react';
import { useSelector } from 'react-redux';
import OpinionItem from 'app/components/opinion/OpinionItem';
import { Empty } from 'app/seedly-component-library';
import Button from 'app/seedly-component-library/button-new';
import Spinner from 'app/seedly-component-library/spinner-new';
import { getHasMoreOpinion } from 'app/reducer/opinionRedux';
import { RootState } from 'app/reducer';
import { Opinion } from 'app/entity/opinion/opinionTypes';

interface OwnProps {
  customEmpty?: React.ReactNode;
  limit?: number;
  opinionItemProps?: {
    opinion: Opinion;
    withComment: boolean;
  };
  handleLoadMoreOpinion?: () => void;
}

const OpinionList = (props: OwnProps) => {
  const {
    customEmpty,
    opinionItemProps = {},
    limit,
    handleLoadMoreOpinion = null,
  } = props;

  const ids = useSelector((state: RootState) => state.opinion.ids);
  const byId = useSelector((state: RootState) => state.opinion.byId);
  const apiStatus = useSelector((state: RootState) => state.opinion.api);
  const hasMoreOpinion = useSelector(getHasMoreOpinion);

  const { isFetching, isFetchingMoreOpinions } = apiStatus;

  let dataSource = ids.map(id => {
    const opinion = byId[id];
    if (!opinion) return null;
    return <OpinionItem key={id} opinion={opinion} {...opinionItemProps} />;
  });

  if (limit) dataSource = dataSource.slice(0, limit);

  const shouldRenderLoadmore = hasMoreOpinion && handleLoadMoreOpinion;

  if (!isFetchingMoreOpinions && isFetching) {
    return (
      <div className="flex flex-col w-full items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="list">
        {dataSource.length > 0
          ? dataSource
          : customEmpty || <Empty title="No opinions found." />}
      </div>
      {shouldRenderLoadmore && (
        <div className="flex flex-col w-full mt-2">
          <Button variant="ghost" onClick={handleLoadMoreOpinion}>
            Load more opinions
          </Button>
        </div>
      )}
    </div>
  );
};

export default OpinionList;
